module.exports = __webpack_public_path__ + "img/14.c3f43e61.svg";